import qs from 'qs';

export function getQueryString(location: any) {
  return qs.parse(location.search.substr(1));
}
